
// Main barrel file that exports all AI services
import { coreAiService } from './coreService';
import { contentGenerationService } from './contentGenerationService';
import { editorialService } from './editorialService';
import { metadataService } from './metadataService';
import { AiRequestParams, AiResponse, AiFeature } from './types';

// Create the openAiService that combines all service functions
export const openAiService = {
  // Core functionality
  generateContent: coreAiService.generateContent,
  chatWithAI: coreAiService.chatWithAI,
  
  // Content generation
  generateTitles: contentGenerationService.generateTitles,
  generateLeadParagraph: contentGenerationService.generateLeadParagraph,
  
  // Editorial services
  factCheck: editorialService.factCheck,
  optimizeWriting: editorialService.optimizeWriting,
  analyzeSeo: editorialService.analyzeSeo,
  
  // Metadata services
  generateTags: metadataService.generateTags,
  findPullQuotes: metadataService.findPullQuotes,
  researchTopic: metadataService.researchTopic
};

// Re-export types
export type { AiRequestParams, AiResponse, AiFeature };
